import { Directive, TemplateRef } from '@angular/core'

@Directive({
	selector: '[uiCommonAccordionHeader]',
})
export class AccordionHeaderDirective {
	constructor(public templateRef: TemplateRef<unknown>) {}
}
